import type { Atom } from "jotai";
import type { JotaiStore } from "./jotai-types.ts";

export function watchAtom<T>(
  store: JotaiStore,
  atom: Atom<T>,
  fn: (value: T) => void,
  eq: (a: T, b: T) => boolean = Object.is,
): () => void {
  let lastValue: any;
  return store.sub(atom, () => {
    const value = store.get(atom);
    if (eq(value, lastValue)) return;
    lastValue = value;
    fn(value);
  });
}
